import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const LicenceItem = (props) => {

    return (
        <div className="licenceItem">
            <p className="title">{props.data.licensable ? props.data.licensable.title : ''}</p>
            <span className="time">{props.data.string_date}</span>
            <span className="score">امتیاز من از این دوره: <b>{props.data.my_score}</b> <i className="icon-black-star-silhouette"></i></span>
            <span className="grade">نمره قبولی : <b>{props.data.pass_score}</b></span>
            <a download={props.data.licensable ? props.data.licensable.title : ''} href={props.data.download_link}>دانلود گواهینامه <i className="icon-arrow-down-sign-to-navigate-fill"></i></a>
            <img src="/svg/licenceSVG.svg" />
        </div>
    );
}

export default LicenceItem;